<template lang="html">
  <div class="upload-main">
    <comp-kick></comp-kick>
    <comp-alive></comp-alive>
    <comp-down></comp-down>
    <div
      class="upload-box"
      ondragenter="event.stopPropagation();event.preventDefault();"
      ondragover="event.stopPropagation();event.preventDefault();"
      ondrop="event.stopPropagation();event.preventDefault();"
    >
    <comp-upload></comp-upload>
    </div>
    <comp-keep></comp-keep>
  </div>
</template>

<script>
import CompKick from '@/app/components/kick.vue'
import CompKeep from '@/app/components/keepAlive.vue'
import CompAlive from '@/app/components/alive.vue'
import CompDown from '@/app/components/download.vue'
import CompUpload from '@/app/views/upload.vue'
import router from '@/router'
import http from '@/http'
export default {
  beforeRouteEnter (to, from, next) {
    if (http.prototype.constructor.defaults.headers['x-us-token'] !== localStorage.getItem('token')) {
      http.prototype.constructor.defaults.headers['x-us-token'] = localStorage.getItem('token')
    }
    http.get('/cydex/api/v1/projects', { params: {
      type: 3
    } })
      .then(response => {
        if (response.data.projects) {
          next()
        } else {
          router.push({ path: '/app/initial' })
        }
      })
  },
  components: {
    CompAlive,
    CompKeep,
    CompKick,
    CompUpload,
    CompDown
  },
  mounted () {
  }
}
</script>

<style lang="css" scoped>
.upload-main {
  position: relative;
  background-color: #fff;
  height: 100%;
}
.upload-box {
  z-index: 2;
  padding-top: 60px;
  position: relative;
  display: flex;
  min-height: 100%;
  background-color: #fff;
  padding-left: calc(100vw - 100%);
}
</style>
